import { render } from "./EposMenuModal.vue?vue&type=template&id=5990984f"
import script from "./EposMenuModal.vue?vue&type=script&lang=js"
export * from "./EposMenuModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__